export const validateEmail = (emailDraft: string): boolean => {
  return Boolean(emailDraft.length && emailDraft.includes('@'))
}
